import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'hover:bg-secondary flex w-full cursor-pointer flex-col gap-3 px-2.5 py-2.5 text-left transition-colors sm:px-4 sm:py-5',
    title: 'heading-s-regular',
    body: 'heading-s whitespace-pre-line',
    footer: 'flex items-center justify-between gap-4',
    action: 'heading-xs text-accent shrink-0',
    time: 'heading-xs text-tertiary shrink-0'
  },
  variants: {
    isRead: {
      true: {
        base: 'bg-surface',
        title: 'heading-s'
      },
      false: {
        base: 'bg-secondary',
        title: 'heading-s-regular'
      }
    }
  },
  defaultVariants: {
    isRead: true
  }
});
